import orders from ".";

export default {
  orders: [],
  sidebar_opened: false,  
  selectedOrders: {},
  occurrences: [],
  pagination: {
    limit: 10,
    offset: 0,
    hasMore: true,
    isLoadingMore: false,
    totalLoaded: 0
  },
  cache: {
    occurrencesLoaded: false,
    ordersLoaded: false
  },  
  activeFilterDate: {
    preset: '90',
    start: '',
    end: '',
    params: null
  } 
}